<template>
    <div>
        <v-form ref="templateEditform" v-model="templateEditFormValid" lazy-validation>

            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <!-- <v-flex xs12 sm12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="templateData.id" 
                            :disabled="!isNew"
                            label="Template Code"
                            hint="Must be an Unique Value"
                            ></v-text-field>
                    </v-flex> -->
                    <v-flex xs12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="templateData.name" 
                            label="Name"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        label="Status"
                        v-bind:items="allStatus"
                        v-model="templateData.status"
                        item-text="name"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                </v-card-text>
                <v-card-actions class="white hide">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="save()">
                    Submit
                    </v-btn>
                    <v-btn class="info" @click="cancel()">
                    Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- {{templateData}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: ['templateData'],
    data () {
        return {
            // templateData: {},
            allStatus: [
                {id: 'editing', name: 'Editing'},
                {id: 'published', name: 'Published'},
                {id: 'hide', name: 'Hide'},
            ],
            templateEditFormValid: true,
            rules: {
                required: v => !!v || "This field is required"
            },

        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return this.templateData && !this.templateData.id
        },
        title () {
            return this.isNew?'Add Template' : 'Edit Template'
        }
    },
    methods: {
        ...mapActions('adminQteTemplate', [
            'getQuoteTemplateForEdit',
            'saveQuoteTemplate',
        ]),
        async save() {
            if (this.$refs.templateEditform.validate()) {
                var result = await this.saveQuoteTemplate(this.templateData)
                this.$emit('onCloseTemplateEdit')
            }
            // this.$router.push({name: 'admin-regions'})
        },
        cancel() {
            // this causes data reload, even it is not necessary
            this.$emit('onCloseTemplateEdit')

            // this.$router.push({name: 'admin-regions'})
        },
    },
    watch: {
        // id: async function (newValue) {
        //     this.templateData = await this.getQuoteTemplateForEdit(newValue)

        // }
    },
    async created () {
        // this.templateData = await this.getQuoteTemplateForEdit(this.id)
    }
}
</script>
